import React, { useMemo } from "react";
import { NavLink } from "react-router-dom";

export default function EBCompnaiesNav() {
  const items = useMemo(() => {
    const navItems = [
      {
        name: "Partners List",
        to: "partner-list",
      },
      {
        name: "Training Materials",
        to: "video-knowledge-base",
      },
      {
        name: "Sales Resources",
        to: "sales-resources",
      },
      {
        name: "Marketing Resources",
        to: "marketing-resources",
      },
      {
        name: "Licenses",
        to: "licenses",
      },
      {
        name: "Blogs",
        to: "blog-management",
      },
      {
        name: "Banner",
        to: "banner-management",
      },
      {
        name: "Courses",
        to: "certification-courses",
      },
      {
        name: "Courses Enrollment",
        to: "course-enrollment",
      },
      {
        name: "Demo Environment Access",
        to: "demo-environment-access",
      },
      {
        name: "Implementation Guild",
        to: "implementation-guild",
      },
      {
        name: "Brochure",
        to: "brochure",
      },
      {
        name: "Discovery",
        to: "discovery",
      },
      {
        name: "Lead Registration Process",
        to: "lead-registration-process",
      },
      {
        name: "Benefit and Requirement",
        to: "benefit-and-requirement",
      },
      {
        name: "Ticketing System",
        to: "ticketing-system",
      },
      {
        name: "Escalation Path",
        to: "escalation-path",
      },
      {
        name: "Pitch Deck",
        to: "pitch-deck",
      },
      {
        name: "One Pager",
        to: "one-pager",
      },
      {
        name: "Project Plan",
        to: "project-plan",
      },
      {
        name: "Data Migration Sheet",
        to: "data-migration-sheet",
      },
      {
        name: "Test Script",
        to: "test-script",
      },
      {
        name: "Tiers",
        to: "tiers",
      },
      {
        name: "Go Live",
        to: "go-live",
      },
    ];

    return navItems;
  });

  return (
    <div className="dashboard-tabs innerpage-tabs px-4">
      <ul className="nav nav-tabs">
        {items.map((item, index) => (
          <li key={index} className="nav-item">
            {item?.type !== undefined ? (
              <NavLink className={`nav-link ga-nav-tab`} href={item.to}>
                {item.name}
              </NavLink>
            ) : (
              <NavLink className={`nav-link ga-nav-tab`} to={item.to}>
                {item.name}
              </NavLink>
            )}
          </li>
        ))}
      </ul>
    </div>
  );
}
